import React from 'react';
import {
	BrowserRouter as Router,
	Switch,
	Route,
	Redirect,
} from 'react-router-dom';
import Home from '../pages/Desktop/Home';
import Flight from '../pages/Desktop/Flight';
import OneWayFlight from '../pages/Desktop/OneWayFlight';
import LoaderModal from '../components/reusableComponents/LoaderModal';
import DashHome from '../components/reusableComponents/DashHome';
import { useSelector } from 'react-redux';
import FlightSummary from '../pages/Desktop/FlightSummary';
import FlightConfirmation from '../pages/Desktop/FlightConfirmation';
import Dashboard from '../pages/Desktop/Dashboard';
import YourTicket from './reusableComponents/YourTicket';
import MainLayout from '../layout/MainLayout';
import Overview from './reusableComponents/Overview';
import MyProfileForm from './reusableComponents/MyProfileForm';
import ChangePasswordForm from './reusableComponents/ChangePasswordForm';
import ManageMarkupForm from './reusableComponents/ManageMarkupForm';
import BankDetails from './reusableComponents/BankDetails';
import BookingHistory from './reusableComponents/BookingHistory';
import TransactionHistory from './reusableComponents/TransactionHistory';
import HomePage from '../pages/Desktop/HomePage';
import HomePage2 from '../pages/Desktop/HomePage2';
import Agents from '../pages/Desktop/Agents';
import AgentSignup from '../components/reusableComponents/AgentSignup';
import BusPage from '../pages/Desktop/BusPage';
import BusPage2 from '../pages/Desktop/Buspage2';
import BusServicePage from '../pages/Desktop/BusServicePage';
import OneWay from '../pages/Desktop/OneWay';
import BusList from '../pages/Desktop/BusList';
import CircularProgress from '@material-ui/core/CircularProgress';
import FlightDeal from '../pages/Desktop/FlightDeal';
import FlightDealCity from '../pages/Desktop/FlightDealCity';
import FlightDealDetailPage from '../pages/Desktop/FlightDealDetailPage';
import FlightDealTable from './reusableComponents/FlightDealTable';
import RoundTrip from '../pages/Desktop/RoundTrip';
import SummaryFlight from '../pages/Desktop/SummaryFlight';
import ConfirmFlight from '../pages/Desktop/ConfirmFlight';
import CheckoutPage from '../pages/Desktop/CheckoutPage';
import About from '../pages/Desktop/About';
import Contact from '../pages/Desktop/Contact';
import Traveller from '../pages/Desktop/Traveller';
import TravellerSignup from './reusableComponents/TravellerSignup';
import AgentInvoice from './reusableComponents/AgentInvoice';
import AccountVerify from '../pages/Desktop/AccountVerify';
import AboutusPage from '../pages/Desktop/AboutusPage';
import ContactusPage from '../pages/Desktop/ContactusPage';
import ManageBooking from '../pages/Desktop/ManageBooking';
import MHome from '../pages/Desktop/MHome';
import TicketDisplay from './reusableComponents/TicketDisplay';
import ManageBookingTicket from './reusableComponents/ManageBookingTicket';
import ResetPassword from '../pages/Desktop/ResetPassword';
const MainRouter = () => {
	const { load } = useSelector((state) => state.etrav);
	const { loading } = useSelector((state) => state.home);
	const { travellerlogin, loadinguser, agentlogin } = useSelector(
		(state) => state.user
	);
	return (
		<div>
			<Router>
				<Switch>
					<Route exact path={'/home'}>
						<Home />
					</Route>
					<Route exact path={'/'}>
						<HomePage />
					</Route>
					<Route exact path={'/m'}>
						<MHome />
					</Route>
					<Route exact path={'/about'}>
						<About />
					</Route>
					<Route exact path={'/aboutus'}>
						<AboutusPage />
					</Route>
					<Route exact path={'/contactus'}>
						<ContactusPage />
					</Route>
					<Route exact path={'/accountVerify'}>
						<AccountVerify />
					</Route>
					<Route exact path={'/contact'}>
						<Contact />
					</Route>
					<Route exact path={'/new'}>
						<HomePage2 />
					</Route>
					<Route exact path={'/flightdeal'}>
						<FlightDeal />
					</Route>
					<Route exact path={'/flightdeal/:city'}>
						<FlightDealCity />
					</Route>
					<Route exact path={'/flightdeal/:city/:detail'}>
						<FlightDealDetailPage />
					</Route>
					<Route exact path={'/flightdealtable'}>
						<FlightDealTable />
					</Route>
					<Route exact path={'/agent'}>
						{agentlogin &&
						agentlogin.result &&
						agentlogin.result.result &&
						agentlogin.result.result.access_token ? (
							<Redirect to='/dashboard' />
						) : loadinguser ? (
							<LoaderModal />
						) : (
							<Agents />
						)}
					</Route>
					<Route exact path={'/traveller'}>
						{travellerlogin &&
						travellerlogin.result &&
						travellerlogin.result.result &&
						travellerlogin.result.result.access_token ? (
							<Redirect to='/dashboard' />
						) : loadinguser ? (
							<LoaderModal />
						) : (
							<Traveller />
						)}
					</Route>
					<Route exact path={'/bus'}>
						<BusPage />
					</Route>
					<Route exact path={'/buses'}>
						<BusServicePage />
					</Route>
					<Route exact path={'/bus2'}>
						<BusPage2 />
					</Route>
					<Route exact path={'/agentsignup'}>
						{loadinguser ? <LoaderModal /> : <AgentSignup />}
					</Route>
					<Route exact path={'/travellersignup'}>
						{loadinguser ? <LoaderModal /> : <TravellerSignup />}
					</Route>
					<Route exact path={'/onewayflight'}>
						<OneWayFlight />
					</Route>
					<Route exact path={'/oneway'}>
						<OneWay />
					</Route>
					<Route extact path={'/roundway'}>
						<RoundTrip />
					</Route>
					<Route exact path={'/buslist'}>
						<BusList />
					</Route>
					<Route exact path={'/flight'}>
						<Flight />
					</Route>
					<Route exact path={'/managebooking'}>
						<ManageBooking />
						{loadinguser ? <LoaderModal /> : ''}
					</Route>
					<Route exact path={'/resetpassword'}>
						<ResetPassword/>
						{loadinguser ? <LoaderModal /> : ''}
					</Route>
					<Route exact path={'/showticket'}>
						<ManageBookingTicket/>
						{loadinguser ? <LoaderModal /> : ''}
					</Route>
					<Route exact path={'/flightsummary'}>
						<FlightSummary />
						{loadinguser ? <LoaderModal /> : ''}
					</Route>
					<Route exact path={'/summaryflight'}>
						<SummaryFlight />
						{loadinguser ? <LoaderModal /> : ''}
					</Route>
					<Route exact path={'/flightconfirm'}>
						<FlightConfirmation />
						{load || loadinguser || loading ? <LoaderModal /> : ''}
					</Route>
					<Route exact path={'/confirmflight'}>
						<ConfirmFlight />
						{load || loadinguser || loading ? <LoaderModal /> : ''}
					</Route>
					<Route exact path={'/dashboardd'}>
						<Dashboard />
					</Route>
					<Route exact path={'/ticket'}>
						<YourTicket />
						{load ? <LoaderModal /> : ''}
					</Route>
					<Route exact path={'/ticketdisplay'}>
						<TicketDisplay/>
						{load ? <LoaderModal /> : ''}
					</Route>
					<Route exact path={'/agentinvoice'}>
						<AgentInvoice />
						{load ? <LoaderModal /> : ''}
					</Route>
					<Route exact path={'/checkout'}>
						<CheckoutPage />
					</Route>
				</Switch>
				<Route path='/dashboard'>
					<MainLayout>
						{loadinguser ? <LoaderModal /> : <DashHome />}
					</MainLayout>
				</Route>
				<Route path='/settings'>
					<MainLayout>
						<DashHome />
					</MainLayout>
				</Route>
				<Route path='/overview'>
					<MainLayout>
						<Overview />
					</MainLayout>
				</Route>
				<Route path='/editprofile'>
					<MainLayout>
						{loadinguser ? <LoaderModal /> : <MyProfileForm />}
					</MainLayout>
				</Route>
				<Route path='/changepassword'>
					<MainLayout>
						{loadinguser ? <LoaderModal /> : <ChangePasswordForm />}
					</MainLayout>
				</Route>
				<Route path='/managemarkup'>
					<MainLayout>
						<ManageMarkupForm />
					</MainLayout>
				</Route>
				<Route path='/bank'>
					<MainLayout>
						<BankDetails />
					</MainLayout>
				</Route>
				<Route path='/bookhistory'>
					<MainLayout>
						<BookingHistory />
						{load || loadinguser || loading ? <LoaderModal /> : ''}
					</MainLayout>
				</Route>
				<Route path='/transactionhistory'>
					<MainLayout>
						<TransactionHistory />
					</MainLayout>
				</Route>
			</Router>
		</div>
	);
};

export default MainRouter;
